const { urlapi } = require("../../lib/backend/data")

const refrescarBodegas = objeto => {
    return {
        type: 'refrescarBodegas',
        payload: objeto
    }
}

const actualizarBodegas = (token) => {
    return async dispatch => {

        return fetch(`${urlapi}/bodega/list-full`,{
            method:'POST',
            body: JSON.stringify({ condicion: { } }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => res.json())
        .then(res => {
            if(Array.isArray(res) !== false){
                dispatch(refrescarBodegas(res))
            }
            return false
        })
        .catch(error => {
            console.log(error.message)
            return false
        })

    }
}

module.exports = {
    actualizarBodegas,
    refrescarBodegas
}